module.exports = {"232763100":"新林镇","232763101":"翠岗镇","232763102":"塔源镇","232763103":"大乌苏镇","232763104":"塔尔根镇","232763105":"碧洲镇","232763106":"宏图镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/232763.json
// module id = 905
// module chunks = 0